import { render, staticRenderFns } from "./WilliamHill.vue?vue&type=template&id=24012233&"
import script from "./WilliamHill.vue?vue&type=script&lang=js&"
export * from "./WilliamHill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports